import { render, staticRenderFns } from "./GroupChip.vue?vue&type=template&id=feba521e"
import script from "./GroupChip.vue?vue&type=script&lang=js"
export * from "./GroupChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports